import { NgClass, SlicePipe } from '@angular/common';
import { Component, Input, OnChanges, inject } from '@angular/core';

import { CrmPromoIdsMap, EventModel, EventOption, EventOptionGroup } from '@frontend/sports/betting-offer/feature/model';
import { MarketGroupingConfig, Sitecore } from '@frontend/sports/common/client-config-data-access';
import { SourceOfPick } from '@frontend/sports/option/pick/feature/tracking';
import { IconCustomComponent } from '@frontend/vanilla/shared/icons';

import { MarketHelpComponent } from './market-help/market-help.component';
import { OptionComponent } from './option.component';

@Component({
    selector: 'ms-total-score-option-group',
    templateUrl: './total-score-option-group.component.html',
    imports: [MarketHelpComponent, OptionComponent, NgClass, SlicePipe, IconCustomComponent],
})
export class TotalScoreOptionGroupComponent implements OnChanges {
    private marketGroupingConfig = inject(MarketGroupingConfig);
    sitecore = inject(Sitecore);

    @Input() event: EventModel;
    @Input() tracking: string;
    @Input() trackingModuleType = '';
    @Input() optionGroup: EventOptionGroup;
    @Input() showMarketHelp: boolean;
    @Input() crmPromoIdsMap: CrmPromoIdsMap;
    @Input() eventHelpText: string;
    @Input() sourceOfPick = SourceOfPick.Other;
    @Input() betDetails = '';
    @Input() optionsLimitOverride?: number;

    expanded = false;
    showMoreLessButtonVisible = false;
    visibleOptionsLimit: number | undefined;
    headerData: string[];

    ngOnChanges(): void {
        this.showMoreLessButtonVisible = this.optionGroup?.options.length > this.marketGroupingConfig.optionGroupRowsThreshold.TotalScore;
        this.calculateMaxNumberOfVisibleOptions();
    }

    trackOption(index: number, eventOption: EventOption): number {
        return eventOption.id;
    }

    onShowMoreLessButtonToggle(): void {
        this.expanded = !this.expanded;
        this.calculateMaxNumberOfVisibleOptions();
    }

    private calculateMaxNumberOfVisibleOptions(): void {
        this.visibleOptionsLimit = this.expanded
            ? undefined
            : (this.optionsLimitOverride ?? this.marketGroupingConfig.optionGroupRowsThreshold.TotalScore);
    }
}
